// extracted by mini-css-extract-plugin
export default {"reset":"cnEYmq","visuallyHidden":"yTIaFZ"};